import React from 'react';
import { ChangePasswordCard } from './components/ChangePasswordCard';
import { LanguageCard } from './components/LanguageCard';
import { ProfileCard } from './components/ProfileCard';
import { useTranslation } from 'react-i18next';
import { PageHeadline } from '../../../components/atoms';

const PreferencesScreen: React.FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-6 pb-8">
      {/* Header */}
      <PageHeadline
        title={t('labels.lblPrefereces')}
        subtitle={t('preferences.subtitle')}
      />

      {/* Profile Section */}
      <div className="flex flex-col gap-4">
        <h3 className="text-lg font-semibold text-gray-700">{t('preferences.profileSettings')}</h3>
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <ProfileCard />
          <LanguageCard />
        </div>
      </div>

      {/* Security Section */}
      <div className="flex flex-col gap-4">
        <h3 className="text-lg font-semibold text-gray-700">{t('preferences.security')}</h3>
        <div className="grid grid-cols-1 gap-6">
          <ChangePasswordCard />
        </div>
      </div>
    </div>
  );
};

export { PreferencesScreen };
